"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _getDependencies = _interopRequireDefault(require("../helpers/getDependencies"));
var _default = exports.default = function _default(_ref) {
  var namespace = _ref.namespace,
    deps = _ref.deps;
  var loadedDeps = (0, _getDependencies.default)(namespace);
  Object.keys(deps).forEach(function (key) {
    if (loadedDeps[key]) return;
    loadedDeps[key] = deps[key];
  });
};